import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import iconHome from '~/assets/images/SidebarIcons/ic_inicio.svg';
import iconHomeSelected from '~/assets/images/SidebarIcons/ic_inicio_selected.svg';
import iconMyAccount from '~/assets/images/SidebarIcons/ic_minha-conta.svg';
import iconMyAccountSelected from '~/assets/images/SidebarIcons/ic_minha-conta_selected.svg';
import iconClub from '~/assets/images/SidebarIcons/ic_clube.svg';
import iconClubSelected from '~/assets/images/SidebarIcons/ic_clube_selected.svg';
import iconJobControl from '~/assets/images/SidebarIcons/megaphone.svg';
import iconJobControlSelected from '~/assets/images/SidebarIcons/megaphone_selected.svg';
import iconBook from '~/assets/images/SidebarIcons/book_white.svg';
import iconBookSelected from '~/assets/images/SidebarIcons/book_blue.svg';
import diamante from '~/assets/images/SidebarIcons/diamante_branco.svg';
import diamanteSelected from '~/assets/images/SidebarIcons/diamante_selected.svg';
import diamante_lapidar from '~/assets/images/SidebarIcons/diamante_select.svg';
import diamante_purple from '~/assets/images/SidebarIcons/diamante_purple.svg';
import iconWalletBlue from '~/assets/images/SidebarIcons/wallet-white.svg';
import iconWalletSelected from '~/assets/images/SidebarIcons/wallet-blue.svg';
import iconDashboardVendas from '~/assets/images/SidebarIcons/ic_dashboard-vendas.svg';
import iconDashboardVendasSelected from '~/assets/images/SidebarIcons/ic_dashboard-vendas_selected.svg';

import DesktopVersion from './DesktopVersion';
import MobileVersion from './MobileVersion';

import { Container, NavigationContainer, Children } from './styles.js';
import { analytics, logEvent } from '~/services/firebaseConfig';
import { verifyRoles } from '~/utils/functions/verifyRoles.js';
import { isDashboardVendasCoreAllowed } from '~/config/dashboardVendas';
import { useSelector, useDispatch } from 'react-redux';
import HistoryIcon from '~/assets/images/SidebarIcons/calendar_selected.svg';
import HistoryIconWhite from '~/assets/images/SidebarIcons/calendar.svg';

export default function SideBar(props) {
  const [loadingLapidar, setLoadingLapidar] = useState(true);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );

  useEffect(() => {
    setTimeout(() => {
      setLoadingLapidar(false);
    }, 3000);
    if (economicGroupReducer.stores.length > 0) {
      setLoadingLapidar(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classificationReducer.pendenciesOn]);

  let routes = [
    {
      title: 'Início',
      selectedIcon: iconHomeSelected,
      icon: iconHome,
      path: '/portal',
      event: 'home_inicio',
      roleName: 'INICIO',
    },
    {
      title: 'Minha Conta',
      selectedIcon: iconMyAccountSelected,
      icon: iconMyAccount,
      path: '/minha-conta',
      event: 'home_minha_conta',
      roleName: 'MINHA_CONTA',
    },
    {
      title: 'Painel 360°',
      selectedIcon: iconDashboardVendasSelected,
      icon: iconDashboardVendas,
      path: '/dashboard-vendas',
      event: 'home_dashboard_vendas',
      roleName: 'DASHBOARD_VENDAS',
    },
    {
      title: 'Portal de Compras',
      selectedIcon: iconClubSelected,
      icon: iconClub,
      path: '/portal-de-compras',
      event: 'home_clube_compras',
      roleName: 'CLUBE_DE_COMPRAS',
    },
    {
      title: 'Desafio Lapidar',
      selectedIcon: diamante_purple,
      icon: diamante_lapidar,
      path: '/lapidar',
      event: 'home_lapidar',
      roleName: 'LAPIDAR',
    },
    {
      title: 'Marketing',
      selectedIcon: iconJobControlSelected,
      icon: iconJobControl,
      path: '/marketing',
      event: 'home_campanha_marketing',
      roleName: 'MARKETING',
    },
    {
      title: 'Universidade Ultragaz',
      selectedIcon: iconBookSelected,
      icon: iconBook,
      path: '/universidade-ultragaz',
      event: 'universidade_ultragaz',
      roleName: 'AJUDA',
    },
  ];

  let routesLapidar = [
    {
      title: 'Início',
      selectedIcon: iconHomeSelected,
      icon: iconHome,
      path: '/lapidar',
      event: 'home_inicio',
      roleName: 'INICIO',
    },
    {
      title: 'Calendário de Avaliações',
      selectedIcon: HistoryIcon,
      icon: HistoryIconWhite,
      path: '/lapidar/calendario-de-avaliacoes',
      event: 'home_historico_avaliacoes',
      roleName: 'HISTORICO_DE_AVALIACOES',
      disabled: false,
    },
    {
      title: 'Histórico de Desafios',
      selectedIcon: diamanteSelected,
      icon: diamante,
      path: '/lapidar/extract-history',
      event: 'home_clube_compras',
      roleName: 'CLUBE_DE_COMPRAS',
      disabled: false,
    },
    {
      title: 'Resgatar pontos',
      selectedIcon: iconClubSelected,
      icon: iconClub,
      path: '/lapidar/vouchers',
      event: 'home_campanha_marketing',
      roleName: 'MARKETING',
    },
    {
      title: 'Carteira de pontos',
      selectedIcon: iconWalletSelected,
      icon: iconWalletBlue,
      path: '/lapidar/wallet',
      event: 'home_wallet',
      roleName: 'CARTEIRA',
    },
  ];

  const selected = props.menuSelected;
  const history = useHistory();
  const dispatch = useDispatch();
  const roles = useSelector(state => state.rolesReducer.roles);

  // Remove Marketing se usuário não tiver papel de marketing
  if (verifyRoles(roles, 'MARKETING') === false) {
    routes = routes.filter(function (route) {
      return route.roleName != 'MARKETING';
    });
  }

  // Remove painel de metas 360° se usuário não tiver papel ou núcleo (core) liberado
  if (
    verifyRoles(roles, 'DASHBOARD_VENDAS') === false ||
    !isDashboardVendasCoreAllowed()
  ) {
    routes = routes.filter(function (route) {
      return route.roleName != 'DASHBOARD_VENDAS';
    });
  }

  async function handleSelect(object) {
    if (window.location.pathname === '/valegas') {
      dispatch({ type: 'SET_DATE', begin: '', end: '' });
    }
    const pathSelected = !object.disabled ? object.path : selected;
    logEvent(analytics, object.event);

    if (pathSelected !== '/job-control' && !object.disabled) {
      if (typeof pathSelected === 'string' && pathSelected.startsWith('http')) {
        window.location.href = pathSelected;
        return;
      }
      if (pathSelected === '/lapidar') {
        setTimeout(() => {
          if (verifyRoles(roles, 'DESAFIO_LAPIDAR')) {
            history.push(pathSelected);
          }
        }, 900);
      } else {
        history.push(pathSelected);
      }
    }
    if (object.event === 'universidade_ultragaz') {
      dispatch({ type: 'SET_CLICKED_FAQ', clicked: true });
    }
  }

  return (
    <Container>
      <NavigationContainer disabledOnMobile={props.disabledOnMobile}>
        <DesktopVersion
          routesLapidar={routesLapidar}
          handleSelect={handleSelect}
          selected={selected}
          lapidar={window.location.pathname.slice(0, 8) === '/lapidar'}
          HistoryIcon={HistoryIcon}
          routes={routes}
          verifyRoles={verifyRoles}
          loadingLapidar={loadingLapidar}
          roles={roles}
          {...props}
        />
        <MobileVersion
          selected={selected}
          lapidar={window.location.pathname.slice(0, 8) === '/lapidar'}
          routesLapidar={routesLapidar}
          handleSelect={handleSelect}
          HistoryIcon={HistoryIcon}
          routes={routes}
          verifyRoles={verifyRoles}
          loadingLapidar={loadingLapidar}
          roles={roles}
          {...props}
        />
      </NavigationContainer>
      <Children lapidar={window.location.pathname.slice(0, 8) === '/lapidar'}>
        {props.children}
      </Children>
    </Container>
  );
}
